<template>
    <div class="compare-navigation__item-switcher" :class="getSwitchStatus ? getSwitchColor[activeColor] : ''" @click="onSwitch"></div>
</template>
<script>
export default {
    props: {
        activeColor:{default:'blue'},
        classSwitcher:{default:true}
    },
    data() {
        return {
            classActive:this.classSwitcher
        }
    },
    methods : {
        onSwitch() {
            this.classActive = !this.classActive
            this.$emit('switchStatus', this.classActive)
        }
    },
    computed : {
        getSwitchColor() {
            let classColors = {
                blue:'compare-navigation__item-switcher-on',
                green:'compare-navigation__item-switcher-on-green',
                red:'compare-navigation__item-switcher-on-red',
                purple:'compare-navigation__item-switcher-on-purple',
                orange:'compare-navigation__item-switcher-on-orange',
                yellow:'compare-navigation__item-switcher-on-yellow',
                fiolet:'compare-navigation__item-switcher-on-fiolet'
            }
            return classColors
        },
        getSwitchStatus() {
            return this.classSwitcher
        }
    }
}
</script>
<style lang="less" scoped>
.compare-navigation
{
    min-width: 240px;
    background-color: #3d536b;
    margin-right: 1px;

    &__title
    {
        font-family: Arimo;
        font-size: 13px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 3.08;
        letter-spacing: 0.4px;
        color: #ffffff;
        text-transform: uppercase;
        padding-left: 12px;
    }

    &__item
    {
        display: flex;
        padding: 12px;
        justify-content: space-between;
        align-items: center;
        border-top: 1px  solid #324258;

        &:hover
        {
            background: #506b89;
        }

        &-title
        {
            font-family: Arimo;
            font-size: 13px;
            font-weight: bold;
            font-style: normal;
            font-stretch: normal;
            line-height: 3.08;
            letter-spacing: 0.4px;
            color: #ffffff;
            text-transform: uppercase;
        }

        &-data
        {
            &-balance
            {
                font-family: Arimo;
                font-size: 13px;
                font-weight: bold;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.23;
                letter-spacing: 0.4px;
                color: @colors[green];
            }

            &-profit
            {
                opacity: 0.9;
                font-family: Arimo;
                font-size: 11px;
                font-weight: normal;
                font-style: normal;
                font-stretch: normal;
                line-height: 1.45;
                letter-spacing: 0.4px;
                color: #0fd7b7;
            }
        }

        &-switcher
        {
            display: inline-block;
            width: 23px;
            height: 14px;
            border-radius: 19px;
            z-index: 0;
            margin: 0;
            padding: 0;
            border: 2px solid #718da8;
            cursor: pointer;
            position: relative;
            transition-duration: 300ms;

            &::after
            {
                content: "";
                height: 10px;
                width: 10px;
                border-radius: 17px;
                background: #718da8;
                top: 2px;
                left: 2px;
                transition-duration: 300ms;
                position: absolute;
                z-index: 1;
            }
        }

        &-switcher-on
        {
            border: 2px solid #36e2ff;

            &::after
            {
                left: 11px;
                background: #36e2ff;
            }
        }

        &-switcher-on-green
        {
            border: 2px solid @colors[green] !important;

            &::after
            {
                left: 11px !important;
                background: @colors[green] !important;
            }
        }

        &-switcher-on-red
        {
            border: 2px solid @colors[red] !important;

            &::after
            {
                left: 11px !important;
                background: @colors[red] !important;
            }
        }

        &-switcher-on-purple
        {
            border: 2px solid #ff79e2 !important;

            &::after
            {
                left: 11px !important;
                background: #ff79e2 !important;
            }
        }

        &-switcher-on-orange
        {
            border: 2px solid #ffad66 !important;

            &::after
            {
                left: 11px !important;
                background: #ffad66 !important;
            }
        }

        &-switcher-on-yellow
        {
            border: 2px solid #ecff24 !important;

            &::after
            {
                left: 11px !important;
                background: #ecff24 !important;
            }
        }

        &-switcher-on-fiolet
        {
            border: 2px solid #a7aeff !important;

            &::after
            {
                left: 11px !important;
                background: #a7aeff !important;
            }
        }
    }
}
</style>
